import React, { useState, useEffect, useRef, useMemo } from "react";
import { useAuth } from "../../utils/hooks/useAuth";
import { routeUrls } from "../../config/routeUrls";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ProfileDropDown: React.FC = () => {
    const { user } = useAuth();

    const { t } = useTranslation();

    const dropDownRef = useRef<null | HTMLDivElement>(null);

    const [isOpenDropDown, setIsOpenDropDown] = useState(false);

    const openCloseDropDown = () => {
        setIsOpenDropDown(!isOpenDropDown);
    }

    useEffect(() => {
        const listener = (e: any) => {
            if (dropDownRef && dropDownRef.current != null) {
                if (!dropDownRef.current.contains(e.target)) {
                    setIsOpenDropDown(false);
                }
            }
        }

        document.addEventListener('click', listener);

        return () => {
            document.removeEventListener('click', listener);
        }
    }, []);

    const getInitials = useMemo(() => {
        if (!!user) {
            const arrayFullName = user.fullName.split(' ');
            const initials: any = [];
            arrayFullName.forEach(word => {
                if (!!word && !!word[0]) {
                    initials.push(word[0])
                }
            })

            return initials.join('');
        }

        return '';
    }, [user])

    return (
        <div className="relative">
            <div ref={dropDownRef} onClick={openCloseDropDown} className="h-[42px] w-[42px] relative select-none cursor-pointer rounded-full bg-[#F9F7F6] text-black text-[20px] uppercase flex items-center justify-center">
                {
                    user &&
                    getInitials
                }
            </div>

            {
                isOpenDropDown &&
                <div className="min-w-[175px] border border-[#6F6F6F] p-[10px] absolute z-10 bg-white right-0 top-[calc(100%+10px)] rounded-[8px]">
                    <Link to={routeUrls.profile} className="mb-[10px] block cursor-pointer">
                        {t('components.profileDropDown.profile')}
                    </Link>
                    <Link to={routeUrls.logout}>
                        <div className="flex justify-between items-center cursor-pointer">
                            <div>{t('components.profileDropDown.logout')}</div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16 13V11H7V8L2 12L7 16V13H16Z" fill="#CF0A2C" />
                                    <path d="M20 3H11C9.897 3 9 3.897 9 5V9H11V5H20V19H11V15H9V19C9 20.103 9.897 21 11 21H20C21.103 21 22 20.103 22 19V5C22 3.897 21.103 3 20 3Z" fill="#CF0A2C" />
                                </svg>
                            </div>
                        </div>
                    </Link>
                </div>
            }
        </div>

    );
}

export default ProfileDropDown;